<script setup>
// The SLA report's three numbers as the kit's tiles (R4). A hit rate with no conversation under an SLA was not
// measured: "-" (7-10); the counts stay as measured.
import { computed } from 'vue';
import StatTile from 'dashboard/components-next/polaris/cards/StatTile.vue';

const props = defineProps({
  hitRate: {
    type: String,
    required: true,
  },
  noOfBreaches: {
    type: Number,
    required: true,
  },
  noOfConversations: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const rate = computed(() => (props.noOfConversations ? props.hitRate : '-'));
const count = value => Number(value || 0).toLocaleString();
</script>

<template>
  <div class="grid gap-4 sm:grid-cols-3" data-sla-metrics>
    <StatTile
      :label="$t('SLA_REPORTS.METRICS.HIT_RATE.LABEL')"
      :info="$t('SLA_REPORTS.METRICS.HIT_RATE.TOOLTIP')"
      :value="rate"
      :loading="isLoading"
    />
    <StatTile
      :label="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.LABEL')"
      :info="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.TOOLTIP')"
      :value="count(noOfBreaches)"
      :loading="isLoading"
    />
    <StatTile
      :label="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.LABEL')"
      :info="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.TOOLTIP')"
      :value="count(noOfConversations)"
      :loading="isLoading"
    />
  </div>
</template>
